import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";
import { ApiError } from "../api.ts";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const me = await login(email, password);
      if (me.memberships.length === 1) {
        nav(`/t/${me.memberships[0]!.slug}/strategic`);
      } else {
        nav("/tenants");
      }
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.status === 401) setError("E-mail ou senha incorretos.");
        else setError(err.message);
      } else {
        setError("Erro inesperado.");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <p className="eyebrow">Acesso</p>
        <h1 className="crown">EcommerceDashboard</h1>
        <p className="sub">Operação 360 — receita, tráfego, mídia, num só lugar.</p>
        <form className="form" onSubmit={onSubmit}>
          <label>
            E-mail
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
          </label>
          <label>
            Senha
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {error && <div className="err">{error}</div>}
          <button className="btn" type="submit" disabled={busy}>
            {busy ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
